import { render, staticRenderFns } from "./SlideCopyV2.vue?vue&type=template&id=57308644&scoped=true"
import script from "./SlideCopyV2.vue?vue&type=script&lang=js"
export * from "./SlideCopyV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57308644",
  null
  
)

export default component.exports